/**
 * `<ChatThinkingIndicator>` — Architect-visual placeholder bubble (Y bundle
 * / spec §10.1.a). Replaces the Phase 2a `<AiThinkingIndicator>` (which used
 * the older `askChat*` CSS family) with the Architect-styled bubble shape.
 *
 * Renders inline at the END of the message list when visible — same DOM
 * slot the real assistant reply will occupy. No layout shift when the
 * indicator unmounts and the real bubble takes its place.
 *
 * Visibility decision is the surface's: typically `replyPending && !pulse`
 * so an active tool-pulse takes precedence over the generic indicator.
 */

import type { JSX } from "react";

export function ChatThinkingIndicator(props: { visible: boolean }): JSX.Element | null {
  if (!props.visible) return null;
  return (
    <div className="opAiChatRow opAiChatRowAssistant">
      <div className="opAiChatMeta"></div>
      <div className="opAiChatBubbleAssistant">
        <div className="opAiChatProse" style={{ fontStyle: "italic", opacity: 0.6 }}>
          Thinking…
        </div>
      </div>
    </div>
  );
}
